<template>
  <div class="page-container">
    <NavBarAdmin />
    <div class="loader" id="updateLoader">
      <span class="helper" id="updateHelper"></span>
      <div id="updateTrans">
        <img src="../../img/loader.gif" /><br />
        <a id="updateLink" target="_blank">Track your transaction</a>
      </div>
      <div id="dbLoading">
        <img src="../../img/loader.gif" /><br />
        <div>Saving your transaction</div>
      </div>
    </div>
    <div class="page-inner-wrapper">
      <h3 class="table-headline">Edit offer</h3>
      <div class="page-bubble">
        <input type="hidden" v-model="currentOffer.id" class="form-control" />
        <input
          type="hidden"
          v-model="currentOffer.companyCode"
          class="form-control"
          placeholder="companyCode"
          readonly
        />
        <input
          type="hidden"
          v-model="currentOffer.offerCode"
          class="form-control"
          placeholder="offerCode"
          readonly
        />
        <label for="location">Location</label>
        <select
          v-model="currentOffer.locationCode"
          class="form-control"
          placeholder="Location Code"
        >
          <option
                v-for="location in locations"
                :value="location.locationCode"
                v-bind:key="location.locationCode"
              >{{ location.locationName }}</option>
          <!-- <option value disabled>Select a Location</option>
          <option value="073">Blagoevgrad</option>
          <option value="078">Kyustendil</option>
          <option value="096">Montana</option>
          <option value="068">Lovech</option>
          <option value="076">Pernik</option>
          <option value="064">Pleven</option>
          <option value="720">Sofia</option>
          <option value="002">Sofia-City</option>
          <option value="094">Vidin</option>
          <option value="092">Vratsa</option> -->
        </select>
        <label for="when">When</label>
        <select
          v-model="currentOffer.dayType"
          class="form-control"
          placeholder="When"
        >
          <option value disabled>Select a day type</option>
          <option value="weekdays">weekdays</option>
          <option value="weekends">weekends</option>
          <option value="alldays">alldays</option>
        </select>
        <label for="dateFrom">Date from</label>
        <input
          type="date"
          v-model="currentOffer.dateFrom"
          class="form-control"
          placeholder="Date from"
        />
        <label for="dateTo">Date to</label>
        <input
          type="date"
          v-model="currentOffer.dateTo"
          class="form-control"
          placeholder="Date to"
        />
        <label for="timeFrom">Time from</label>
        <input
          type="time"
          v-model="currentOffer.timeFrom"
          class="form-control"
          placeholder="Time from"
        />
        <label for="timeTo">Time to</label>
        <input
          type="time"
          v-model="currentOffer.timeTo"
          class="form-control"
          placeholder="Time to"
        />
        <label for="volume">Volume (KWh)</label>
        <input
          type="text"
          v-model="currentOffer.volume"
          class="form-control"
          placeholder="Volume (KWh)"
        />
        <label for="price">Price (&euro;/KWh)</label>
        <input
          type="text"
          v-model="currentOffer.price"
          class="form-control"
          placeholder="Price (&euro;/KWh)"
        />
        <button type="submit" class="offer-add-button" @click="updateOffer">
          Update
        </button>
        <button class="offer-remove-button" @click="deleteOffer">Delete</button>
        <p>{{ message }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import LocationDataService from "../../services/LocationDataService";
import AssetDataService from "../../services/AssetDataService";
import OfferDataService from "../../services/OfferDataService";
import NavBarAdmin from "../../components/Common/NavBarAdmin";
export default {
  name: "offer",
  components: { NavBarAdmin },
  data() {
    return {
      currentOffer: {
        id: 1,
        locationCode: "002",
        dayType: "weekends",
        dateFrom: "30/08/2020",
        dateTo: "02/09/2020",
        timeFrom: "10:00",
        timeTo: "18:00",
        volume: "10KWh",
        price: "30.00",
      },
      message: "",
      locations: [],
      countryCode: this.$store.state.auth.user.countryCode,
    };
  },
  methods: {

    retrieveLocations(countryCode) {
      LocationDataService.findBySubCountryCode(countryCode)
        .then((response) => {
          this.locations = response.data;
          console.log("HERE... load locations sucessfull: " + response.data);
        })
        .catch((e) => {
          console.log("HERE... load locations zones error: " + e);
        });
    },

    retrieveAssets(companyCode) {
      AssetDataService.findByCompanyCode(companyCode)
        .then((response) => {
          this.assets = response.data;
          console.log("HERE... load assets sucessfull: " + response.data);
        })
        .catch((e) => {
          console.log("HERE... load assets error: " + e);
        });
    },

    getOffer(id) {
      OfferDataService.get(id)
        .then((response) => {
          this.currentOffer = response.data;
          console.log(response.data);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    async updateOffer() {
      await this.Apps.updateFlexOffer();
        document.getElementById("updateLoader").style.display = "block";
        document.getElementById("dbLoading").style.display = "inline-block";
        OfferDataService.update(this.currentOffer.id, this.currentOffer)
        .then((response) => {
            document.getElementById("updateLoader").style.display = "none";
            document.getElementById("dbLoading").style.display = "none";
            this.$store.commit("change", false);
            console.log("HERE response data: " + response.data);
            this.message = "The offer was updated successfully!";
            this.$router.push({ name: "offersAdmin" });
        })
        .catch((e) => {
          console.log("Error", e);
        });
    },
     
    deleteOffer() {
      OfferDataService.delete(this.currentOffer.id)
        .then((response) => {
          console.log(response.data);
          this.$router.push({ name: "offersAdmin" });
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  mounted() {
    this.message = "";
    this.$store.state.auth.user;
    this.retrieveAssets(this.$store.state.auth.user.companyCode);
    this.retrieveLocations(this.$store.state.auth.user.countryCode);
    this.getOffer(this.$route.params.id);
  },
};
</script>

<style lang="scss">
@import "../../sass/main.scss";
.nav-bar {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  margin-top: -100px;
  margin-left: -10px;
}
.page-inner-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 40px;
}
.page-bubble {
  box-shadow: 0 4px 6px 0 hsla(0, 0, 0, 0.2);
  background: #fff;
  padding: 40px;
  width: 70%;
  margin-right: 40px;
  overflow-x: hidden;
}
.page-bubble label {
  display: block;
  font-size: 0.9em;
  margin: 0 0 3px 5px;
}
.page-bubble input,
.page-bubble select {
  width: 100%;
  padding: 6px 10px;
  border-radius: 10px;
  border: 1px solid #ccc;
  margin-bottom: 20px;
}
.page-bubble input:focus,
.page-bubble select:focus {
  outline: none;
  border: 1px solid #6680a0;
  box-shadow: 0 0 5px #c8d2da;
}
.offer-add-button {
  font-size: 0.9rem;
  color: $black;
  padding: 6px 15px;
  background: #bfecb5;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  margin-right: 20px;
  margin-top: 20px;
}
.offer-remove-button {
  font-size: 0.9rem;
  color: $black;
  padding: 6px 15px;
  background: #f8736b;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  margin-top: 20px;
}
.edit-form {
  max-width: 300px;
  margin: auto;
}
.loader {
  background: rgba(0, 0, 0, 0.4);
  display: none;
  height: 100%;
  position: fixed;
  text-align: center;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.loader .offerHelper {
  display: none;
  height: 40%;
  vertical-align: middle;
}
.loader > div {
  background-color: #fff;
  box-shadow: 10px 10px 60px #555;
  display: none;
  width: 20%;
  position: fixed;
  border-radius: 8px;
  padding: 15px 5%;
  margin-top: 19%;
  margin-left: -10%;
}

.updateLink:hover {
  text-decoration: underline;
}


</style>